import { render, staticRenderFns } from "./adminRoles.vue?vue&type=template&id=7dec9736"
import script from "./adminRoles.vue?vue&type=script&lang=js"
export * from "./adminRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports